<template>
  <div class="transfer-device-dialog">
    <custom-dialog width="1380px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <div class="item-title">{{ $t('dms_edit_biz_device_dialog.he_tong_xin_xi') }}</div>
        <div class="item-title-info">
          <el-row>
            <el-col :span="8">
              <span class="label">{{ $t('dms_edit_biz_device_dialog.he_tong_bian_hao') }}:</span>
              <span class="value">{{ bizInfo.contractNo || '-' }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">{{ $t('dms_edit_biz_device_dialog.ye_wu_lei_xing') }}:</span>
              <span class="value">{{ getDicValue('dms_device_biz_class', bizInfo.deviceBizClass) }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">{{ $t('dms_edit_biz_device_dialog.ku_cun_fang') }}:</span>
              <span class="value">{{ bizInfo.orgName || '-' }}</span>
            </el-col>
          </el-row>
        </div>
        <div class="item-title">{{ $t('dms_edit_biz_device_dialog.ye_wu_xin_xi') }}</div>
        <el-form :model="form" label-position="top" ref="form">
          <el-form-item :label="$t('dms_edit_biz_device_dialog.ye_wu_lei_xing')" prop="bizType" class="is-required">
            <el-radio-group v-model="form.bizType">
              <el-radio :label="90" :disabled="bizInfo.orgType == 'CS'">{{ $t('dms_edit_biz_device_dialog.ku_cun') }}</el-radio>
              <el-radio :label="10" :disabled="bizInfo.orgType == 'HQ' || bizInfo.orgType == 'JV' || bizInfo.orgType == 'JV_SC'">{{ $t('dms_edit_biz_device_dialog.shi_yong') }}</el-radio>
              <el-radio :label="20" :disabled="bizInfo.orgType == 'HQ' || bizInfo.orgType == 'JV' || bizInfo.orgType == 'JV_SC'">{{ $t('dms_edit_biz_device_dialog.zu_lin') }}</el-radio>
              <el-radio :label="40" :disabled="bizInfo.orgType == 'HQ'">{{ $t('dms_edit_biz_device_dialog.xiao_shou') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="table-bd">
          <div class="item-title">{{ $t('dms_edit_biz_device_dialog.she_bei_xin_xi') }}</div>
          <custom-table
            index
            tableCode="stockTransfer1"
            :data="tableList"
            :filterArr="form.bizType == '90' ? ['orderCharged', 'rentalStartTime', 'rentalEndTime'] : []"
            :slots="['deviceBizType', 'orderCharged', 'rentalStartTime', 'rentalEndTime', 'locationSiteName']"
          >
            <template v-slot:deviceBizType="scope">
              <custom-select :clearable="false" v-model="scope.row.deviceBizType" code="dms_device_biz_type" :props="{ label: 'name', value: 'value' }" width="100%"></custom-select>
            </template>
            <template v-slot:orderCharged="scope">
              <custom-select :clearable="false" v-model="scope.row.orderCharged" code="isynergy_cloud_bool" width="100%"></custom-select>
            </template>
            <template v-slot:rentalStartTime="scope">
              <custom-date-picker
                style="width: 100%"
                v-model="scope.row.rentalStartTime"
                type="date"
                :placeholder="scope.$index === 0 ? '' : $t('dms_edit_biz_device_dialog.mo_ren_tong_shang')"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="{
                  disabledDate(time) {
                    return scope.row.rentalEndTime ? $moment(time).isAfter(new Date(`${scope.row.rentalEndTime}Z`).getTime(), 'day') : undefined;
                  },
                }"
              ></custom-date-picker>
            </template>
            <template v-slot:rentalEndTime="scope">
              <custom-date-picker
                style="width: 100%"
                v-model="scope.row.rentalEndTime"
                type="date"
                :placeholder="scope.$index === 0 ? '' : $t('dms_edit_biz_device_dialog.mo_ren_tong_shang')"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="{
                  disabledDate(time) {
                    return scope.row.rentalStartTime
                      ? $moment(time).isBefore(new Date(`${scope.row.rentalStartTime}Z`).getTime(), 'day') || $moment(time).isBefore(new Date().getTime(), 'day')
                      : $moment(time).isBefore(new Date().getTime(), 'day');
                  },
                }"
              ></custom-date-picker>
            </template>
            <template v-slot:locationSiteName="scope" >
              <el-input size="small"  v-model="scope.row.locationSiteName" :placeholder="scope.$index === 0 ? '' : $t('dms_edit_biz_device_dialog.mo_ren_tong_shang')" style="width: 120px; vertical-align: middle" :disabled="true"></el-input>
              <el-button size="small" :disabled="!bizInfo.orgId" style="margin-left: 8px; float: none; vertical-align: middle" type="text" @click="onSelectDialog(scope.row, scope.$index)">{{ $t('dms_edit_biz_device_dialog.xuan_ze') }}</el-button>
            </template>
          </custom-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
    <location-site-select-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onConfirmLocation"></location-site-select-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import locationSiteSelectDialog from '@/pages/dms/components/location_site_select_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: { locationSiteSelectDialog },
  data() {
    return {
      rowIndex: 0,
      bizInfo: {},
      tableList: [],
      form: {
        bizType: '',
      },
      dialogModel: {},
      dialogVisible: false,
    };
  },
  mounted() {
    this.getDeviceBizInfo();
  },
  methods: {
    //  获取业务信息详情
    getDeviceBizInfo: function () {
      this.$getJSON(`${apis.MyDeviceBizInfo}/${this.model.row.contractNo}`).then((res) => {
        this.bizInfo = res.data;
        this.form.bizType = this.bizInfo.deviceBizClass;
        const list = res.data.deviceList || [];
        list.forEach((item) => {
          item.deviceBizType = item.deviceBizType || '';
          item.orderCharged = item.orderCharged || '1';
          item.rentalStartTime = item.rentalStartTime || '';
          item.rentalEndTime = item.rentalEndTime || '';
          item.locationId = item.locationId || '';
          item.locationName = item.locationName || '';
          item.siteId = item.siteId || '';
          item.siteName = item.siteName || '';
          item.locationSiteName = `${item.locationName}/${item.siteName}`;
        });
        this.tableList = list;
      });
    },
    // 选择项目区域
    onSelectDialog: function (row, index) {
      this.rowIndex = index;
      this.dialogModel.title = this.$t('dms_edit_biz_device_dialog.xuan_ze_xiang_muo', [this.bizInfo.orgName]);
      this.dialogModel.row = {
        ...row,
        orgId: this.bizInfo.orgId,
        orgName: this.bizInfo.orgName,
      };
      this.dialogVisible = true;
    },
    // 确认项目区域
    onConfirmLocation: function (form) {
      const idx = this.rowIndex;
      this.tableList[idx]['locationId'] = form.locationId;
      this.tableList[idx]['locationName'] = form.locationName;
      this.tableList[idx]['siteId'] = form.siteId || '';
      this.tableList[idx]['siteName'] = form.siteId ? (form.siteName || '-') : '';
      this.tableList[idx]['locationSiteName'] = form.siteId ? `${form.locationName}/${form.siteName || '-'}` : form.locationName;
      const data = this.tableList;
      this.tableList = [];
      this.$nextTick(() => {
        this.tableList = data;
      });
    },
    // 提交
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (`${this.form.bizType}` !== '90' && !this.tableList[0]['locationId']) {
          this.$message.error(this.$t('dms_edit_biz_device_dialog.qxzxm'));
          return;
        }
        const list = this.tableList;
        if (`${this.form.bizType}` === '90') {
          list.forEach((item) => {
            item.orderCharged = '';
            item.rentalStartTime = '';
            item.rentalEndTime = '';
          });
        }
        this.$postJSON(apis.MyDeviceBizUpdate, {
          deviceList: list,
          contractNo: this.model.row.contractNo,
          toDeviceBizClass: this.form.bizType,
        }).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.visible = false;
          this.clearKeepAlive('mybizdevice');
          this.$emit('success');
        });
      });
    },
  },
};
</script>

<style lang="scss">
.transfer-device-dialog .label-white .el-form-item__label {
  opacity: 0;
}
</style>
